import { CORE_VALUES } from "@/data/content";
import { useReveal } from "@/hooks/useReveal";
import {
  ShieldCheck,
  HandHeart,
  Sun,
  Users,
  ClipboardCheck,
} from "lucide-react";

const ICONS = [ShieldCheck, HandHeart, Sun, Users, ClipboardCheck];

export default function CoreValues() {
  return (
    <section
      id="wartosci"
      data-testid="values-section"
      className="relative py-24 lg:py-36 bg-[var(--ikra-bg)]"
    >
      <div className="max-w-[1280px] mx-auto px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="text-xs uppercase tracking-[0.2em] text-[var(--ikra-muted)] flex items-center gap-3">
            <span className="inline-block h-px w-8 bg-[var(--ikra-gold-bright)]" />
            Nasze wartości
          </div>
          <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-[64px] leading-[1.02] tracking-tight text-[var(--ikra-ink)] uppercase">
            Wartości, na których{" "}
            <span className="text-[var(--ikra-gold)]">stoi</span> cała firma.
          </h2>
        </div>

        <div className="mt-16 lg:mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-16 lg:gap-y-20 gap-x-10 lg:gap-x-14">
          {CORE_VALUES.map((v, i) => (
            <Value key={v.title} v={v} Icon={ICONS[i]} i={i} />
          ))}
        </div>
      </div>
    </section>
  );
}

function Value({ v, Icon, i }) {
  const ref = useReveal();
  return (
    <div
      ref={ref}
      data-testid={`value-${v.title}`}
      className="reveal text-center"
      style={{ animationDelay: `${i * 100}ms` }}
    >
      <div className="inline-flex h-16 w-16 items-center justify-center rounded-full border border-[var(--ikra-line)] text-[var(--ikra-gold-bright)]">
        <Icon size={26} strokeWidth={1.5} />
      </div>
      <h3 className="mt-7 font-display text-xl lg:text-2xl text-[var(--ikra-ink)] tracking-tight uppercase leading-tight">
        {v.title}
      </h3>
      <span className="mt-3 inline-block h-0.5 w-8 bg-[var(--ikra-gold-bright)]" />
      <p className="mt-5 text-[15px] text-[var(--ikra-muted)] leading-relaxed max-w-[320px] mx-auto">
        {v.text}
      </p>
    </div>
  );
}
